import { Container, Link, Typography } from "@mui/material";
import React from "react";

export const ReportDisclaimer = () => {
  return (
    <Container maxWidth="md" sx={{ textAlign: "center" }}>
      <Typography color="textGrey.main" variant="body3" textAlign="center">
        Kreditingumo įvertinimas yra UAB SCORIFY nuomonė apie įmonės kreditingumą išreikšta naudojant nustatytą ir
        apibrėžtą vertinimo skalę. SCORIFY nuomonė nebūtinai turi sutapti su kreditorių ar pačios įmonės nuomone apie
        jos kreditingumą.
        <Link href="https://www.scorify.ai/" target="_blank" ml="0.25rem" color="inherit">
          Plačiau apie SCORIFY
        </Link>
      </Typography>
    </Container>
  );
};
